import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EffectsModule } from "@ngrx/effects";
import { Conf2Effects } from "./+state/effects";

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([Conf2Effects])]
})
export class Conf2DataAccessModule {}
